import {showToast, ToastType} from "./toast-message";

let ssoChannel: BroadcastChannel | null = null;

export type SessionAction =
    | 'SSO_LOGIN'
    | 'SSO_REDIRECT_TO_TOOL'
    | 'SSO_LOGOUT'
    | 'SSO_EXPIRED'
    | 'SSO_NEW_SESSION';

export interface SessionMessage {
    action: SessionAction;
    payload?: Record<string, unknown>;
}

function syncAnotherTabRedirect(payload: Record<string, unknown> | undefined, message: string, type: ToastType) {
    if (!payload) return;

    let url = payload['url'] && typeof payload['url'] === 'string' ? payload['url'] : null;

    showToast({
        message: message, type: type, duration: 5 * 1000, onDismiss: () => {
            if (url) {
                window.location.replace(url)
            }
        }
    });
}

export function initSessionBroadcast() {
    if (!('BroadcastChannel' in window)) {
        console.warn('BroadcastChannel not supported.');
        return;
    }

    // 2. Initialize the channel
    ssoChannel = new BroadcastChannel('scw_df_sso');

    // 3. Attach the listener
    ssoChannel.onmessage = (event: MessageEvent<SessionMessage>) => {
        if (!event?.data?.action) {
            return;
        }

        const {action, payload} = event.data;

        switch (action) {
            case "SSO_LOGIN":
                syncAnotherTabRedirect(payload, 'Logged in another tab/window.', "success");
                break;
            case "SSO_REDIRECT_TO_TOOL":
                syncAnotherTabRedirect(payload, 'Redirected on another tab/windows, sync in progress', "info");
                break;
            case "SSO_NEW_SESSION":
                showToast({
                    message: 'New Login Session Started on another tab/window. This session is invalidated.',
                    type: 'warning'
                });
                break;
        }
    };

    setTimeout(() => {
        ssoChannel?.close();
        ssoChannel = null;
    }, 15 * 60 * 1000)
}

// 4. Expose a helper function to safely broadcast from your login forms
export function broadcastSsoStateChange(message: SessionMessage) {
    if (ssoChannel) {
        ssoChannel.postMessage(message);
    }
}